import React from 'react';
import { RoundButton } from '../';
import './styles.css';

const RoundInputNumber = ({
  value,
  onIncrease,
  onDecrease,
  inputColor,
  inputBackgroundColor,
  buttonsColor,
  buttonsBackgroundColor,
}) => (
  <div className="round-input-number">
    {value !== 0 &&
      <RoundButton
        content={<div>-</div>}
        disabled={false}
        onClick={onDecrease}
        color={buttonsColor}
        borderColor={buttonsColor}
        backgroundColor={buttonsBackgroundColor}
        flat
      />
    }
    <input
      value={value}
      type="number"
      disabled
      style={{
        color: inputColor,
        backgroundColor: inputBackgroundColor,
      }}
    />
    <RoundButton
      content={<div>+</div>}
      disabled={false}
      onClick={onIncrease}
      color={buttonsColor}
      borderColor={buttonsColor}
      backgroundColor={buttonsBackgroundColor}
      flat
    />
  </div>
);

RoundInputNumber.propTypes = {
  value: React.PropTypes.number.isRequired,
  onIncrease: React.PropTypes.func.isRequired,
  onDecrease: React.PropTypes.func.isRequired,
  inputColor: React.PropTypes.string.isRequired,
  inputBackgroundColor: React.PropTypes.string.isRequired,
  buttonsColor: React.PropTypes.string.isRequired,
  buttonsBackgroundColor: React.PropTypes.string.isRequired,
};

export default RoundInputNumber;



// WEBPACK FOOTER //
// ./src/browser/app/components/RoundInputNumber/RoundInputNumber.js